var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBluePen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.895749 12.572C0.804623 12.5718 0.714527 12.5524 0.63119 12.515C0.547853 12.4776 0.473098 12.423 0.41168 12.3546C0.34915 12.2869 0.301436 12.2065 0.271666 12.1187C0.241896 12.0309 0.230743 11.9378 0.238938 11.8453L0.399857 10.0493L7.83364 2.50664L10.1568 4.86397L2.72497 12.406L0.955519 12.5693C0.935649 12.5712 0.915703 12.5721 0.895749 12.572ZM10.6205 4.39264L8.298 2.03531L9.6911 0.621306C9.7521 0.559321 9.82454 0.510149 9.90427 0.476599C9.98401 0.44305 10.0695 0.425781 10.1558 0.425781C10.2421 0.425781 10.3276 0.44305 10.4073 0.476599C10.487 0.510149 10.5595 0.559321 10.6205 0.621306L12.0136 2.03531C12.0746 2.09722 12.1231 2.17075 12.1561 2.25168C12.1892 2.33261 12.2062 2.41936 12.2062 2.50697C12.2062 2.59458 12.1892 2.68133 12.1561 2.76227C12.1231 2.8432 12.0746 2.91672 12.0136 2.97864L10.6211 4.39197L10.6205 4.39264Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBluePen);
export default __webpack_public_path__ + "static/media/ic_blue_pen.8c9da81c94409eb48372390648e1a639.svg";
export { ForwardRef as ReactComponent };